import React from 'react';
import { MdClose, MdWarning } from 'react-icons/md';
import { PiWarningBold } from "react-icons/pi";
import "../../styles/DeleteConfirmModal.css";

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, partnerName }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content-admin">
        <div className="modal-header">
         <h6><span className='warning-icon me-1'><PiWarningBold/></span>Delete Partner</h6>
          <button className="close-btn-delete" onClick={onClose}>
            <MdClose />
          </button>        
        </div>
        
        <div className="modal-body">
          <p>Are you sure you want to delete <strong>{partnerName}</strong>?</p>
        </div>
        
        <div className="modal-footer-delete">
          <button className="delete-btn" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;